import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { 
  UsersGroups, 
  CreateUsersGroups, 
  UpdateUsersGroups,
  DeleteUserGroup, 
  GroupRoleModule, 
  CreateGroupRoleModule
} from "./users-groups.interface";

export const userGroupApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getUsersGroups: builder.query<APIResponse<UsersGroups[]>,void>({
        query: () => ({
          url: "auth/users-groups"
        }),
        providesTags: ["UserGroup"],
    }),

    getActiveUsersGroups: builder.query<APIResponse<UsersGroups[]>, void>({
      query: () => ({
        url: "auth/users-groups/active"
      }),
      providesTags: ["UserGroup"],
    }),

    getUserGroupById: builder.query<APIResponse<UsersGroups>,number>({
      query: (id) => ({ url:`/users/${id}`}),
      providesTags: (_result, _error, id) => [{ type: 'UserGroup', id }],
    }),
    
    // Crear un nuevo usuario
    createUserGroup: builder.mutation<APIResponse<UsersGroups>, CreateUsersGroups>({
      query: (data) => ({
        url: 'auth/users-groups',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UserGroup'],
    }),

    updateUserGroup: builder.mutation<APIResponse<UsersGroups>, { id: number; changes: UpdateUsersGroups }>({
      query: ({ id, changes }) => ({
        url: `auth/users-groups/${id}`,
        method: 'PATCH',
        body: changes,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'UserGroup', id },'UserGroup'],
    }),

    deleteUserGroup: builder.mutation<APIResponse<DeleteUserGroup>, number>({
      query: (id) => ({
        url: `auth/users-groups/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UserGroup'],
    }),
          

    getGroupRoleModule: builder.query<APIResponse<GroupRoleModule[]>,void>({
        query: () => ({
          url: "auth/grm-relation"
        }),
        providesTags: ["UserGroup"],
    }),

    getGroupRoleModuleByGroupid: builder.query<APIResponse<GroupRoleModule[]>,number>({
      query: (id) => ({ url:`auth/grm-relation/group/${id}`}),
      providesTags: (_result, _error, id) => [{ type: 'UserGroup', id }],
    }),

    createGroupRoleModule: builder.mutation<APIResponse<GroupRoleModule>, CreateGroupRoleModule>({
      query: (data) => ({
        url: 'auth/grm-relation',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UserGroup'],
    }),

    updateRolInGroupRoleModule: builder.mutation<APIResponse<GroupRoleModule>, {id: number, role_id:number}>({
      query: ({id,role_id}) => ({
        url: 'auth/grm-relation/update',
        method: 'POST',
        body: {id,role_id},
      }),
      invalidatesTags: ['UserGroup'],
    }),

    deleteGroupRoleModule: builder.mutation<APIResponse<null>, number>({
      query: (id) => ({
        url: `auth/grm-relation/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    })

  }),

});


// Exportar hooks generados
export const {
  useGetUsersGroupsQuery,
  useGetActiveUsersGroupsQuery,
  useGetUserGroupByIdQuery,
  useCreateUserGroupMutation,
  useUpdateUserGroupMutation,
  useDeleteUserGroupMutation,
  useGetGroupRoleModuleQuery,
  useGetGroupRoleModuleByGroupidQuery,
  useLazyGetGroupRoleModuleByGroupidQuery,
  useCreateGroupRoleModuleMutation,
  useUpdateRolInGroupRoleModuleMutation,
  useDeleteGroupRoleModuleMutation
} = userGroupApi;
